import type { CustomerMembershipDto } from "../api/hooks/useMemberships";

/** "All access", "All access · Silver", or "All access, Silver and 2 more". */
export function formatMembershipNames(memberships: CustomerMembershipDto[]): string {
  const names = memberships.map((membership) => membership.tierName);
  if (names.length <= 2) {
    return names.join(" · ");
  }

  return `${names[0]}, ${names[1]} and ${names.length - 2} more`;
}
